import axios from 'axios'
// import moment from 'moment'

export async function getReservation( packet ) {
  let params = `res_token=${ packet.res_token }`

  try {
    return await axios.get( '/reservations/get_reservation.json?' + params, {
    } )
  } catch {
    return { status: 400 }
  }
}

export async function deleteReservation( res_token ) {
  if ( res_token == null ) {
    return
  }

  let params = {
    res_token
  }
  
  let csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  try {
    return await axios.post( '/reservations/delete_reservation.json', params, {   
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrf_token,
      }
    } )
  } catch {
    return { status: 400 }
  }
}